import React, { useMemo, useState } from "react";
import SectionHeading from "@/components/common/SectionHeading";
import EventCard from "@/components/common/EventCard";
import { Spinner, EmptyState } from "@/components/common/Primitives";
import { isUpcoming } from "@/lib/format";
import { useEvents } from "@/hooks/useSiteQueries";

export default function EventsPage() {
  const { data: events, isPending } = useEvents();
  const [tab, setTab] = useState("upcoming");

  const shown = useMemo(() => {
    if (!events) return null;
    const upcoming = events
      .filter((e) => isUpcoming(e.event_date))
      .sort((a, b) => new Date(a.event_date) - new Date(b.event_date));
    const past = events.filter((e) => !isUpcoming(e.event_date));
    return tab === "upcoming" ? upcoming : past;
  }, [events, tab]);

  return (
    <div data-testid="events-page">
      <section className="bg-maroon text-white">
        <div className="container-bcs py-20 sm:py-24">
          <p className="eyebrow !text-gold-light mb-4">Our Events</p>
          <h1 className="heading-xl !text-white max-w-3xl">
            Conventions, drives, camps and <span className="italic text-gold-light">celebrations.</span>
          </h1>
          <p className="mt-6 text-white/80 max-w-2xl text-lg leading-relaxed">
            From Sabha Day to deanery-level drives — everything happening across our units and forums.
          </p>
        </div>
      </section>

      <section className="container-bcs py-14 sm:py-16">
        <div className="flex gap-2">
          {["upcoming", "past"].map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-colors ${
                tab === t ? "bg-maroon text-white" : "bg-white border border-gray-200 text-ink-soft hover:border-maroon hover:text-maroon"
              }`}
              data-testid={`events-tab-${t}`}
            >
              {t === "upcoming" ? "Upcoming" : "Past events"}
            </button>
          ))}
        </div>

        {isPending ? (
          <Spinner />
        ) : shown.length === 0 ? (
          <EmptyState title={`No ${tab} events`} message="Please check back soon." />
        ) : (
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {shown.map((e) => (
              <EventCard key={e.slug} event={e} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
